export default "__VITE_ASSET__98321967__"